export default __webpack_public_path__ + "static/media/feather _ arrow-up_chart.d8b985a1.svg";